"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridBody = void 0;
var react_1 = __importDefault(require("react"));
var react_window_1 = require("react-window");
var __1 = require("../");
var GKDataGridWrapper_1 = require("../GKDataGridWrapper");
var GKDataGridBody = function (props) {
    var gridCtx = react_1.default.useContext(__1.GKDataGridContext);
    var gridWrapperCtx = react_1.default.useContext(GKDataGridWrapper_1.GKDataGridWrapperContext);
    var gridElement = document.querySelector(".gk-data-grid-v2");
    var cellHeight = gridElement
        ? parseFloat(getComputedStyle(gridElement).getPropertyValue("--initial-cell-height"))
        : 0;
    var children = props.children, listRef = props.listRef, loading = props.loading, _a = props.rowCount, rowCount = _a === void 0 ? 5 : _a, tbodyRef = props.tbodyRef, virtualize = props.virtualize, passthroughProps = __rest(props, ["children", "listRef", "loading", "rowCount", "tbodyRef", "virtualize"]);
    // If we're loading, or if not virtualized, we don't need the virtualization stuff.
    if (loading || !virtualize) {
        return (react_1.default.createElement("div", __assign({}, passthroughProps, { ref: tbodyRef }), children));
    }
    /*
      Notes:
      1. The body height is the height of the grid wrapper, minus the height of the header and footer.
      2. The listRef and tbodyRef are used by GKDataGrid, which is why we pass those refs in as props.
      3. The virtualized table doesn't use children, because it needs to pass index/style on each row.
    */
    return (react_1.default.createElement(react_window_1.VariableSizeList, __assign({ estimatedItemSize: cellHeight, height: (gridWrapperCtx.height || 0) -
            (gridCtx.headHeight || 0) -
            (gridCtx.footHeight || 0), itemCount: rowCount, itemSize: loading ? function () { return cellHeight; } : gridCtx.getRowHeight, ref: listRef, outerRef: tbodyRef, width: "100%" }, passthroughProps), function (_a) {
        var _b;
        var virtualIndex = _a.index, style = _a.style;
        return ((_b = gridCtx.getRow) === null || _b === void 0 ? void 0 : _b.call(gridCtx, virtualIndex, style)) || react_1.default.createElement("div", null);
    }));
};
exports.GKDataGridBody = GKDataGridBody;
